var styles = {
  "CloseButton": "Polaris-Modal-CloseButton"
};

export { styles as default };
